import { Injectable, inject } from '@angular/core';
import { NgrxHttpClient } from '@library/utils/services/http-service';

import { Observable } from 'rxjs';
import { User } from './user.interface';

@Injectable()
export class UserService {
  private readonly http = inject(NgrxHttpClient);

  getUser(): Observable<User> {
    return this.http.get('getuser');
  }
}
